<template>
  <div class="question-notes">
    <div v-if="can('create') && isHidden" class="question-notes__add">
      <button @click.prevent="showNote()" class="question-notes__add-btn">
        Add a note
      </button>
    </div>
    <div v-if="createOrUpdate && isVisible" class="question-notes__inner">
      <div v-if="isVisible">
        <div class="question-notes__input-wrap">
          <button
            type="button"
            @click="removeNote"
            class="question-notes__remove"
          >
            <span class="question-notes__remove-text">Remove note</span>
            ×
          </button>
          <textarea
            placeholder="Add your note here"
            v-model="note.text"
            name="text"
            class="question-notes__textarea"
          >
          </textarea>
        </div>
        <div class="question-notes__save">
          <div v-if="createOrUpdate">
            <button
              class="question-notes__save-button"
              type="button"
              :disabled="!note.text"
              @click="saveNote()"
            >
              <transition name="fade" mode="out-in">
                <span :key="loading">
                  {{ loading ? 'Saving...' : 'Save note' }}
                </span>
              </transition>
            </button>
          </div>
        </div>
        <label class="question-notes__action">
          <input
            class="question-notes__action-checkbox"
            type="checkbox"
            name="requires_action"
            v-model="note.requires_action"
            value="1"
            :disabled="!note.text"
          />
          <span class="question-notes__action-label">
            Requires action from the Baby Charter Lead
          </span>
        </label>
      </div>
    </div>
    <div v-else-if="can('action')" class="question-notes__inner">
      <div class="grid__col-24 grid__col-lg-16">
        <p>
          <strong>Bliss note</strong><br />
          {{ note.text }}
        </p>
      </div>
      <label class="question-notes__action">
        <input
          @change="actionNote()"
          class="question-notes__action-checkbox"
          type="checkbox"
          name="is_actioned"
          v-model="note.is_actioned"
        />
        <span class="question-notes__action-label">
          I have made all required updates
        </span>
      </label>
    </div>
    <div v-else-if="can('view') && note.text" class="question-notes__inner">
      <div class="grid__col-24 grid__col-lg-16">
        <p>
          {{ note.text }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: {
    activeNote: null,
    notePermissions: Object,
  },

  data() {
    return {
      note: {
        text: null,
        requires_action: 0,
        actioned_at: 0,
        is_actioned: false,
      },
      permissions: this.notePermissions,
      hidden: true,
      loading: false,
    };
  },

  computed: {
    // Can the note be created or updated
    createOrUpdate() {
      return this.permissions.create || this.permissions.update;
    },
    isHidden() {
      return this.hidden;
    },
    isVisible() {
      return !this.hidden;
    },
    noteHasText() {
      return this.note;
    },
  },

  mounted() {
    // If we have an active notes, assign its properties to the note field
    if (this.activeNote) {
      this.hidden = false;
      Object.keys(this.note).forEach(
        (field) => (this.note[field] = this.activeNote[field])
      );
    }
  },

  methods: {
    // Check the user permission
    can(permission) {
      return this.permissions[permission];
    },

    // Reset the note property
    resetNote() {
      Object.assign(this.note, this.$options.data().note);
    },

    removeNote() {
      // If we have a note to delete, remove it from the database
      if (this.can('delete')) {
        this.deleteNote();
      } else {
        this.hidden = true;
      }
      // Reset the note property
      this.resetNote();
    },

    showNote() {
      this.hidden = false;
    },

    deleteNote() {
      this.loading = true;
      let route = this.permissions['delete'];

      axios
        .delete(route)
        .then((response) => {
          // Update note data
          this.activeNote = null;

          // Hide the note component
          this.hidden = true;

          // Update permissions
          this.permissions = response.data.permissions;
        })
        .catch((error) => {
          alert('Note couldnt be deleted');
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },

    actionNote() {
      let route = this.permissions['action'];
      this.loading = true;

      this.updateOrCreateNote(route, this.note);
    },

    saveNote() {
      let route = this.permissions['create'] || this.permissions['update'];
      this.loading = true;

      setTimeout(() => this.updateOrCreateNote(route, this.note), 1000);
    },

    updateOrCreateNote(route, params) {
      axios
        .post(route, params)
        .then((response) => {
          // Update note data
          let updatedNote = response.data.data;
          Object.keys(this.note).forEach(
            (field) => (this.note[field] = updatedNote[field])
          );

          // Update permissions
          this.permissions = response.data.permissions;
        })
        .catch((error) => {
          alert('Note couldnt be saved');
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter, .fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
